"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var response_exports = {};
__export(response_exports, {
  apiErrorResponse: () => apiErrorResponse,
  badGatewayToNetworkError: () => badGatewayToNetworkError,
  contentAs: () => contentAs,
  createResponse: () => createResponse,
  debugResponse: () => debugResponse,
  foldResponse: () => foldResponse,
  mapResponse: () => mapResponse,
  notFoundToOption: () => notFoundToOption,
  optionalContentAs: () => optionalContentAs,
  parseAs: () => parseAs,
  readAsJson: () => readAsJson,
  readAsText: () => readAsText,
  recoverUnknownErrors: () => recoverUnknownErrors,
  responseToIO: () => responseToIO,
  successResponse: () => successResponse,
  successResponseNoContent: () => successResponseNoContent,
  unknownErrorResponse: () => unknownErrorResponse,
  validationErrorsToChecked: () => validationErrorsToChecked
});
module.exports = __toCommonJS(response_exports);
var import_fp = require("@cartographerio/fp");
var import_guard = require("@cartographerio/guard");
var import_io = require("@cartographerio/io");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_status = require("./status.js");
function successResponseNoContent(underlying) {
  return { type: "SuccessResponseNoContent", underlying };
}
function successResponse(underlying, content) {
  return { type: "SuccessResponse", underlying, content };
}
function apiErrorResponse(underlying, error) {
  return { type: "ApiErrorResponse", underlying, error };
}
function unknownErrorResponse(underlying, content) {
  return { type: "UnknownErrorResponse", underlying, content };
}
function debugResponse(message) {
  return function(response) {
    console.warn(message, response);
    return response;
  };
}
function createResponse(underlying) {
  if ((0, import_status.is2xx)(underlying.status)) {
    return import_io.IO.pure(successResponseNoContent(underlying));
  } else {
    return import_io.IO.fromPromise(() => underlying.json()).map(
      (content) => (0, import_types.isApiError)(content) ? apiErrorResponse(underlying, content) : unknownErrorResponse(underlying, content)
    );
  }
}
function foldResponse(response, callbacks) {
  switch (response.type) {
    case "SuccessResponse":
      return callbacks.success(response);
    case "ApiErrorResponse":
      return callbacks.failure(response);
    case "UnknownErrorResponse":
      return callbacks.unknown(response);
  }
}
function mapResponse(response, func) {
  return foldResponse(response, {
    success: (r) => successResponse(response.underlying, func(r.content)),
    failure: (r) => r,
    unknown: (r) => r
  });
}
function readAsJson(response) {
  switch (response.type) {
    case "SuccessResponseNoContent":
      return import_io.IO.fromPromise(() => response.underlying.json()).map(
        (content) => successResponse(response.underlying, content)
      );
    case "ApiErrorResponse":
    case "UnknownErrorResponse":
      return import_io.IO.pure(response);
    default:
      return (0, import_util.checkExhausted)(response);
  }
}
function readAsText(response) {
  switch (response.type) {
    case "SuccessResponseNoContent":
      return import_io.IO.fromPromise(() => response.underlying.text()).map(
        (content) => successResponse(response.underlying, content)
      );
    case "ApiErrorResponse":
    case "UnknownErrorResponse":
      return import_io.IO.pure(response);
    default:
      return (0, import_util.checkExhausted)(response);
  }
}
function parseAs(hint, guard) {
  return (response) => {
    return foldResponse(response, {
      success: (response2) => guard(response2.content) ? import_io.IO.pure({ ...response2, content: response2.content }) : import_io.IO.fail((0, import_guard.guardError)(hint, guard, response2.content)),
      failure: (response2) => import_io.IO.fail(response2.error),
      unknown: (response2) => import_io.IO.fail(badGatewayToNetworkError(response2))
    });
  };
}
function validationErrorsToChecked(response) {
  return foldResponse(response, {
    success: (response2) => mapResponse(response2, import_types.checkedSuccess),
    failure: (response2) => (0, import_types.isValidationError)(response2.error) ? successResponse(response2.underlying, (0, import_types.checkedFailure)(response2.error.errors)) : response2,
    unknown: (response2) => response2
  });
}
function notFoundToOption(response) {
  return foldResponse(response, {
    success: (response2) => ({
      ...response2,
      content: import_fp.Option.some(response2.content)
    }),
    failure: (response2) => (0, import_types.isNotFoundError)(response2.error) ? successResponse(response2.underlying, import_fp.Option.none()) : response2,
    unknown: (response2) => response2
  });
}
function recoverUnknownErrors(handlers) {
  return (response) => foldResponse(response, {
    success: (response2) => response2,
    failure: (response2) => response2,
    unknown: ({ underlying, content }) => handlers[underlying.status]?.(content) ? successResponse(underlying, content) : response
  });
}
function responseToIO(response) {
  return foldResponse(response, {
    success: (response2) => import_io.IO.pure(response2.content),
    failure: (response2) => import_io.IO.fail(response2.error),
    unknown: (response2) => import_io.IO.fail(badGatewayToNetworkError(response2))
  });
}
function contentAs(hint, guard) {
  return (response) => foldResponse(response, {
    success: (response2) => guard(response2.content) ? import_io.IO.pure(response2.content) : import_io.IO.fail((0, import_guard.guardError)(hint, guard, response2.content)),
    failure: (response2) => import_io.IO.fail(response2.error),
    unknown: (response2) => import_io.IO.fail(badGatewayToNetworkError(response2))
  });
}
function optionalContentAs(hint, guard) {
  return (response) => foldResponse(response, {
    success: (response2) => contentAs(hint, guard)(response2).map(import_fp.Option.some),
    failure: (response2) => (0, import_types.isNotFoundError)(response2.error) ? import_io.IO.pure(import_fp.Option.none()) : import_io.IO.fail(response2.error),
    unknown: (response2) => import_io.IO.fail(badGatewayToNetworkError(response2))
  });
}
function badGatewayToNetworkError(response) {
  return response.underlying.status === 502 ? (0, import_types.networkError)("502 Bad Gateway", response) : response.content;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  apiErrorResponse,
  badGatewayToNetworkError,
  contentAs,
  createResponse,
  debugResponse,
  foldResponse,
  mapResponse,
  notFoundToOption,
  optionalContentAs,
  parseAs,
  readAsJson,
  readAsText,
  recoverUnknownErrors,
  responseToIO,
  successResponse,
  successResponseNoContent,
  unknownErrorResponse,
  validationErrorsToChecked
});
//# sourceMappingURL=response.js.map
